import { createAction, ActionType } from 'typesafe-actions'

export const setIsExternalAction = createAction('SET_IS_EXTERNAL')<boolean>()

export const setPermissionsAction = createAction('SET_PERMISISONS')<string[]>()

export type PermissionActions =
  | ActionType<typeof setIsExternalAction>
  | ActionType<typeof setPermissionsAction>
